export const createFormData = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (key === "categories" && typeof data[key] === "string") {
      // Категорії передаються як JSON рядок
      formData.append(key, data[key]);
    } else if (Array.isArray(data[key])) {
      data[key].forEach((item) => {
        formData.append(key, item);
      });
    } else {
      formData.append(key, data[key]);
    }
  });
  return formData;
};
